export enum ShedType {
  Warehouse = 1, //Loods
  FieldShed = 2, //Veldschuur
  SideWaysShed = 3 //Lessenaar
};